"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilesTable = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const HeaderRow_1 = require("./components/HeaderRow");
const FilesTableContext_1 = require("./FilesTableContext");
const Body_1 = require("./components/Body");
const lib_1 = require("../../lib");
const FilesTable = props => {
    const { className } = props;
    return ((0, jsx_runtime_1.jsx)(FilesTableContext_1.FilesTableContext.Provider, Object.assign({ value: props }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: (0, lib_1.classnames)('table', className) }, { children: [(0, jsx_runtime_1.jsx)(HeaderRow_1.HeaderRow, {}, void 0), (0, jsx_runtime_1.jsx)(Body_1.Body, {}, void 0)] }), void 0) }), void 0));
};
exports.FilesTable = FilesTable;
//# sourceMappingURL=FilesTable.js.map